// Маппер товаров (catalog items) — raw snake_case → camelCase DTO

import type { ItemDto, ItemRaw } from '../types/item.types';

export function mapItem(raw: ItemRaw): ItemDto {
  return {
    id: raw.id,
    sku: raw.sku,
    name: raw.name,
    description: raw.description ?? null,
    unit: raw.unit,
    barcodes: raw.barcodes ?? [],
    categoryId: raw.category_id ?? null,
    categoryName: raw.category_name ?? null,
    price: raw.price,
    costPrice: raw.cost_price ?? null,
    quantity: raw.quantity,
    minQuantity: raw.min_quantity ?? null,
    imageUrl: raw.image_url ?? null,
    isActive: raw.is_active,
    createdAt: raw.created_at,
    updatedAt: raw.updated_at,
  };
}
